import { render, staticRenderFns } from "./QuickLinkMenu.vue?vue&type=template&id=ac6c3670"
import script from "./QuickLinkMenu.vue?vue&type=script&lang=ts"
export * from "./QuickLinkMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports